import { motion } from "framer-motion";
import { Reveal, ChapterTag } from "./motion";
import { useStore } from "../../context/StoreContext";
import { eur } from "../../lib/format";
import { Check, Truck } from "lucide-react";

export const PackSelector = () => {
  const { config, selectedPack, selectPack, openCart } = useStore();
  if (!config) return null;

  return (
    <section id="packs" data-testid="pack-selector-section" className="py-16 sm:py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center">
          <div className="flex justify-center"><ChapterTag num="06" label="Offer" /></div>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Choose your pack</h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7 items-stretch">
          {config.packs.map((pack, i) => {
            const selected = selectedPack?.id === pack.id;
            return (
              <Reveal key={pack.id} delay={i * 0.1} className="h-full">
                <motion.button
                  data-testid={`pack-option-${pack.units}`}
                  onClick={() => selectPack(pack.id)}
                  whileTap={{ scale: 0.98 }}
                  className={`relative w-full h-full text-left rounded-3xl p-7 transition-all duration-300 bg-white ${
                    selected
                      ? "ring-2 ring-brand shadow-xl shadow-brand/10"
                      : "ring-1 ring-zinc-200 hover:ring-zinc-300 hover:shadow-lg"
                  }`}
                >
                  {pack.badge && (
                    <span
                      className={`absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap text-[11px] font-bold tracking-wide px-4 py-1.5 rounded-full text-white ${
                        pack.id === "pack_2" ? "bg-brand animate-badge-pulse" : "bg-ink"
                      }`}
                    >
                      {pack.badge}
                    </span>
                  )}
                  <div className="flex items-center justify-between">
                    <span className="font-display font-bold text-lg">{pack.name}</span>
                    <span className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected ? "border-brand bg-brand" : "border-zinc-300"}`}>
                      {selected && <Check className="w-3 h-3 text-white" />}
                    </span>
                  </div>
                  {pack.tagline && <p className="mt-1 text-xs text-zinc-500">{pack.tagline}</p>}
                  <p className="mt-5 font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid={`pack-price-${pack.units}`}>
                    {eur(pack.price)}
                  </p>
                  {pack.units > 1 && (
                    <p className="text-xs text-zinc-400 mt-1">({eur(pack.price / pack.units)}/unit)</p>
                  )}
                  <p className={`mt-4 text-xs font-semibold flex items-center gap-1.5 ${pack.free_shipping ? "text-green-600" : "text-zinc-500"}`}>
                    <Truck className="w-3.5 h-3.5" />
                    {pack.free_shipping ? "FREE SHIPPING" : `+ ${eur(pack.shipping)} shipping`}
                  </p>
                </motion.button>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2}>
          <motion.button
            data-testid="pack-cta-button"
            onClick={() => openCart()}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            className="mt-10 w-full bg-brand hover:bg-brand-dark text-white font-display font-bold text-lg rounded-full px-10 py-5 shadow-lg shadow-brand/30 transition-colors"
          >
            REMOVE THE HAIR NOW
          </motion.button>
          <p className="mt-4 text-center text-xs text-zinc-400">Secure payment with Stripe · Card · Apple Pay · Google Pay</p>
        </Reveal>
      </div>
    </section>
  );
};
